import styled from 'styled-components'
import Color from 'color'

export const TimelineWrapper = styled.div<{ numberOfDays: number }>`
  display: flex;
  position: sticky;
  top: 0;
  border-bottom: 1px solid #e6e8eb;
  box-shadow: 0px 1px 2px rgba(255, 255, 255, 0.25),
    0px 4px 4px rgba(0, 0, 0, 0.03);
  flex-shrink: 0;
  background: #fff;
  z-index: 3;
  min-width: ${props => props.numberOfDays * 100 + 56}px;
`

export const TimezoneContainer = styled.div`
  flex: 0 0 56px;
  border-right: 1px solid #e6e8eb;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: sticky;
  left: 0;
  background-color: #fff;
`

export const TopScrollWrapper = styled.div`
  width: 100%;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: clip;
`

export const Timezone = styled.div`
  display: flex;
  align-items: center;
  height: 56px;
  color: #a1a5b0;
  font-size: 9px;
`

export const Days = styled.div`
  position: sticky;
  top: 0;
  background-color: #fff;
  display: flex;
  height: 55px;
  z-index: 2;
`

export const Day = styled.div<{ leftAlign?: boolean }>`
  flex: 1 0 100px;
  display: flex;
  justify-content: ${props => (props.leftAlign ? 'flex-start' : 'center')};
  align-items: center;
  padding-left: ${props => (props.leftAlign ? '16px' : undefined)};
  position: relative;

  &:not(:last-child) {
    border-right: 1px solid #e6e8eb;
  }

  .week-day {
    text-transform: capitalize;
    color: #a1a5b0;
    font-size: 18px;
  }

  .day-number {
    font-size: 18px;
    font-weight: 600;
    margin-left: 10px;
  }
`

export const AllDayEventsContainer = styled.div`
  display: flex;
  background-color: #fff;
  flex-grow: 1;
`

export const EventCell = styled.div`
  flex: 1 0 100px;
  border-top: 1px solid #e6e8eb;
  border-right: 1px solid #e6e8eb;
  min-width: 0;
  position: relative;

  &:last-child {
    border-right: none;
  }
`

export const Event = styled.div<{ color: string; length: number }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: ${props => Color(props.color).lightness(99).string()};
  border: 1px solid ${props => props.color};
  border-radius: 4px;
  color: ${props => props.color};
  font-size: 14px;
  line-height: 28px;
  font-weight: 500;
  padding: 0 8px;
  cursor: pointer;
  margin-top: 15px;
  position: absolute;
  width: 100%;
  z-index: 1;
  margin-left: 3px;
  margin-right: 3px;
  width: ${props => `calc((100% + 1px) * ${props.length} - 6px)`};

  span {
    max-width: 100%;
    display: inline-block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  &:hover {
    background-color: ${props => Color(props.color).lightness(98).string()};
  }

  img {
    width: 20px;
    height: 20px;
    border-radius: 50%;
  }

  &.open-start {
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: 0;
    width: ${props => `calc((100% + 1px) * ${props.length} - 3px)`};
  }

  &.open-end {
    border-right: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    margin-right: 0;
    width: ${props => `calc((100% + 1px) * ${props.length} - 3px)`};
  }

  &.open-start.open-end {
    width: ${props => `calc((100% + 1px) * ${props.length})`};
  }

  &.unapproved {
    border-style: dashed;
  }
`
